import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { formatViews } from "@/utils/format";

interface Props {
  items: Article[];
}

export default function HotList({ items }: Props) {
  return (
    <ol className="space-y-1">
      {items.map((a, i) => (
        <li key={a.id}>
          <Link
            to={`/detail/${a.id}`}
            className="flex items-start gap-3 py-2.5 group border-b border-background-200 last:border-0"
          >
            <span
              className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                i < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-500"
              }`}
            >
              {i + 1}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {a.title}
              </p>
              <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-line text-accent-500" />
                {formatViews(a.views)} 阅读
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ol>
  );
}